import { getURLOverrideValue } from "../components/DeveloperTools/ServiceUrls/serviceUrlHelpers"
import { LogError } from "../helpers/logger"

import GLOBALS_ENVIRONMENT from "./globalsEnvironment"

//Retrieve the URL for the requested key and check if it has been overridden
const getUrlValue = (envKey) => {
  try {
    const overrideValue = getURLOverrideValue(envKey)

    if (overrideValue.overrideUrl) {
      return overrideValue.overrideUrl
    } else {
      return process.env[envKey]
    }
  } catch (error) {
    LogError("Unable to retrieve microservice URL value", error)
    return undefined
  }
}

//Decide which environment key should be used to retrieve service URLs
const getUrlForEnvironment = (devKey, stageKey, qaProdKey, prodKey) => {
  let urlKey = undefined

  if (GLOBALS_ENVIRONMENT.isDevelopment) {
    urlKey = devKey
  }
  if (GLOBALS_ENVIRONMENT.isStaging) {
    urlKey = stageKey
  }
  if (GLOBALS_ENVIRONMENT.isQAProduction) {
    urlKey = qaProdKey
  }
  if (GLOBALS_ENVIRONMENT.isProduction) {
    urlKey = prodKey
  }

  return getUrlValue(urlKey || devKey)
}


function notificationsUrl() {
  return getUrlForEnvironment(
    "REACT_APP_NOTIFICATIONS_API_DEV",
    "REACT_APP_NOTIFICATIONS_API_STAGE",
    "REACT_APP_NOTIFICATIONS_API_QAPROD",
    "REACT_APP_NOTIFICATIONS_API_PROD"
  )
}

function tasksUrl() {
  return getUrlForEnvironment(
    "REACT_APP_TASKS_API_DEV",
    "REACT_APP_TASKS_API_STAGE",
    "REACT_APP_TASKS_API_QAPROD",
    "REACT_APP_TASKS_API_PROD"
  )
}

function referralsUrl() {
  return getUrlForEnvironment(
    "REACT_APP_REFERRALS_API_DEV",
    "REACT_APP_REFERRALS_API_STAGE",
    "REACT_APP_REFERRALS_API_QAPROD",
    "REACT_APP_REFERRALS_API_PROD"
  )
}

function gpraUrl() {
  return getUrlForEnvironment(
    "REACT_APP_GPRA_API_DEV",
    "REACT_APP_GPRA_API_STAGE",
    "REACT_APP_GPRA_API_QAPROD",
    "REACT_APP_GPRA_API_PROD"
  )
}

function telerecoveryApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_TWILIO_MICROSERVICE_API_DEV",
    "REACT_APP_TWILIO_MICROSERVICE_API_STAGE",
    "REACT_APP_TWILIO_MICROSERVICE_API_QAPROD",
    "REACT_APP_TWILIO_MICROSERVICE_API_PROD"
  )
}

function appointmentsApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_APPOINTMENTS_API_DEV",
    "REACT_APP_APPOINTMENTS_API_STAGE",
    "REACT_APP_APPOINTMENTS_API_QAPROD",
    "REACT_APP_APPOINTMENTS_API_PROD"
  )
}

function documentSigningApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_DOCUMENT_SIGNING_API_DEV",
    "REACT_APP_DOCUMENT_SIGNING_API_STAGE",
    "REACT_APP_DOCUMENT_SIGNING_API_QAPROD",
    "REACT_APP_DOCUMENT_SIGNING_API_PROD"
  )
}

function housingApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_HOUSING_API_DEV",
    "REACT_APP_HOUSING_API_STAGE",
    "REACT_APP_HOUSING_API_QAPROD",
    "REACT_APP_HOUSING_API_PROD"
  )
}

function employmentApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_EMPLOYMENT_MICROSERVICE_API_DEV",
    "REACT_APP_EMPLOYMENT_MICROSERVICE_API_STAGE",
    "REACT_APP_EMPLOYMENT_MICROSERVICE_API_QAPROD",
    "REACT_APP_EMPLOYMENT_MICROSERVICE_API_PROD"
  )
}

function coordinationBoardsApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_COORDINATION_BOARDS_MICROSERVICE_API_DEV",
    "REACT_APP_COORDINATION_BOARDS_MICROSERVICE_API_STAGE",
    "REACT_APP_COORDINATION_BOARDS_MICROSERVICE_API_QAPROD",
    "REACT_APP_COORDINATION_BOARDS_MICROSERVICE_API_PROD"
  )
}

function assessmentsApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_ASSESSMENTS_MICROSERVICE_API_DEV",
    "REACT_APP_ASSESSMENTS_MICROSERVICE_API_STAGE",
    "REACT_APP_ASSESSMENTS_MICROSERVICE_API_QAPROD",
    "REACT_APP_ASSESSMENTS_MICROSERVICE_API_PROD"
  )
}
function kioskApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_KIOSK_API_DEV",
    "REACT_APP_KIOSK_API_STAGE",
    "REACT_APP_KIOSK_API_QAPROD",
    "REACT_APP_KIOSK_API_PROD"
  )
}

function kioskV2ApiUrl() {
  return getUrlForEnvironment(
    "REACT_APP_KIOSKV2_API_DEV",
    "REACT_APP_KIOSKV2_API_STAGE",
    "REACT_APP_KIOSKV2_API_QAPROD",
    "REACT_APP_KIOSKV2_API_PROD"
  )
}

export {
  notificationsUrl,
  tasksUrl,
  referralsUrl,
  gpraUrl,
  telerecoveryApiUrl,
  appointmentsApiUrl,
  documentSigningApiUrl,
  housingApiUrl,
  employmentApiUrl,
  coordinationBoardsApiUrl,
  assessmentsApiUrl,
  kioskApiUrl,
  kioskV2ApiUrl,
}
